// src/config/gauges/fsc_v3_1comp.js

export const fscV31CompGaugeConfig = [
  // 1) Temp Evaporador Salida
  {
    key: "tempEvapSalida",
    title: "Temp. Evap. Salida",
    unit: "°C",
    ranges: [
      { min: 7,  max: 8.99, color: "green" },
      { min: 6,  max: 6.99,  color: "yellow" },
      { min: 9, max: 19.99, color: "yellow" },
      { min: 0, max: 5.99, color: "red" },
      { min: 20, max: 10000,  color: "red" },
    ],
  },

  // 2) Temp Evaporador Entrada
  {
    key: "tempEvapEntrada",
    title: "Temp. Evap. Entrada",
    unit: "°C",
    ranges: [
      { min: 11,  max: 13.99, color: "green" },
      { min: 8,  max: 10.99,  color: "yellow" },
      { min: 14, max: 19.99, color: "yellow" },
      { min: 0, max: 7.99, color: "red" },
      { min: 20, max: 10000,  color: "red" },
    ],
  },

  // 3) Presión Succión Comp 1
  {
    key: "presionSuccionComp1",
    title: "Pres. Succión C1",
    unit: "psi",
    ranges: [
      { min: 110, max: 124.99, color: "green" },
      { min: 100, max: 109.99, color: "yellow" },
      { min: 125, max: 134.99, color: "yellow" },
      { min: 0,  max: 99.99, color: "red" },
      { min: 135, max: 1000,  color: "red" },
    ],
  },

  // 4) Presión Descarga Comp 1
  {
    key: "presionDescargaComp1",
    title: "Pres. Descarga C1",
    unit: "psi",
    ranges: [
      { min: 420, max: 500.99, color: "green" },
      { min: 300, max: 419.99, color: "yellow" },
      { min: 500, max: 549.99, color: "yellow" },
      { min: 0,   max: 299.99, color: "red" },
      { min: 550, max: 10000,   color: "red" },
    ],
  },

  // 5) Sobrecalentamiento Comp 1
  {
    key: "sobrecalentamientoComp1",
    title: "Sobrecalentamiento C1",
    unit: "°C",
    ranges: [
      { min: 10, max: 19.99, color: "green" },
      { min: 5, max: 9.99, color: "yellow" },
      { min: 20, max: 24.99, color: "yellow" },
      { min: -50, max: 4.99, color: "red" },
      { min: 25,  max: 20000, color: "red" },
    ],
  },

  // 6) Temp Succión Comp 1
  {
    key: "tempSuccionComp1",
    title: "Temp Succion",
    unit: "°C",
    ranges: [
      { min: 10, max: 14.99, color: "green" },
      { min: 6, max: 9.99, color: "yellow" },
      { min: 15, max: 19.99, color: "yellow" },
      { min: -50, max: 5.99, color: "red" },
      { min: 20,  max: 20000, color: "red" },
    ],
  },
];